/**
 * Server settings › Overview: "Default notification settings" (Discord's,
 * 2026-10-29): what members who never chose get, All messages or Only
 * @mentions. Saved with the rest of the tab (`PATCH /guilds/{id}`, Manage
 * Server, audited as a server update). Hidden while the Console's
 * `notifications` flag is off.
 */
import { useT } from '../i18n';
import { useFlag } from '../store/config';
import { Seg } from '../ui/kit';

export function DefaultNotifyField({
  value,
  onChange,
}: {
  value: 0 | 1;
  onChange: (v: 0 | 1) => void;
}) {
  const { t } = useT();
  const on = useFlag('notifications');
  if (!on) return null;
  return (
    <div className="ns-field nt-default">
      <span className="ns-label">{t('nt.def.label')}</span>
      <Seg<'0' | '1'>
        label={t('nt.def.label')}
        value={value === 0 ? '0' : '1'}
        onChange={(v) => onChange(v === '0' ? 0 : 1)}
        options={[
          { value: '0', label: t('nt.all') },
          { value: '1', label: t('nt.mentions') },
        ]}
      />
      <span className="ns-help">{t('nt.def.help')}</span>
    </div>
  );
}
